import axios from 'axios';
import { SendNotificationToAllUsersDTO } from '../DTOs';
import { IDeviceRepository } from '../Interfaces';

const baseUrl = `${process.env.REACT_APP_LOYALTY_API}/Device`;

const sendNotificationToAllUsers = async (data: SendNotificationToAllUsersDTO): Promise<void> => {
  await axios.post(`${baseUrl}/SendNotificationToAllUsers`, data);
};

export const DeviceRepository: IDeviceRepository = {
  sendNotificationToAllUsers,
};
